import React, { useState } from 'react';
import './Requester.css';
import Button from '../../components/button';
import CustomInput from '../../components/customInput/CustomInput';
import CustomDatePicker from '../../components/customDatePicker/CustomDatePicker';

function AddRequest({ onCancel }) {
  const [discountedPrice, setDiscountedPrice] = useState('');
  const [promoStartDate, setPromoStartDate] = useState(null);
  const [promoEndDate, setPromoEndDate] = useState(null);
  const [sku, setSku] = useState('');
  const [remark, setRemark] = useState('');

  return (
    <div className="manage-user-container">
      <div style={{ padding: '30px' }}>
        <div style={{ fontSize: '24px', fontWeight: '400' }}>Add Request</div>
        <div style={{ fontSize: '14px', color: '#757575', marginTop: '10px' }}>
          Requester is compulsory to enter the specific SKU and click on Search to get SKU info
        </div>
        <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
          <div>Search by Product Name:</div>
          <div>
            <CustomInput
              style={{ width: '240px', height: '50px', marginLeft: '88px' }}
              placeholder="Enter the SKU"
              value={sku}
              onChange={(e) => setSku(e.target.value)}
            />
          </div>
          <Button className='requester-search-btn' style={{ marginLeft: '100px' }}>SEARCH</Button>
        </div>
        <div style={{ fontSize: '24px', fontWeight: '400', marginTop: '20px' }}>RRP info as below</div>

        <div style={{ marginTop: '20px' }}>

          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
            <div style={{ width: '200px' }}>SKU</div>
            <div style={{ width: '200px', color: '#757575', marginLeft: '88px' }}>320013100N</div>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
            <div style={{ width: '200px' }}>Product Name</div>
            <div style={{ width: '200px', color: '#757575', marginLeft: '88px' }}>Apple iphone 16</div>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
            <div style={{ width: '200px' }}>Retail Price</div>
            <div style={{ width: '200px', color: '#757575', marginLeft: '88px' }}>$2499</div>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <div style={{ width: '200px' }}>Discounted Price</div>
            <div>
              <CustomInput
                style={{ marginLeft: '88px', width: '240px', height: '50px' }}
                type="text"
                placeholder="Enter the discounted price"
                value={discountedPrice}
                onChange={(e) => setDiscountedPrice(e.target.value)}
              />
            </div>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <div style={{ width: '200px' }}>Promo Start Date</div>
            <div>
              <CustomDatePicker
                className='add-request-datepicker'
                placeholderText="Select Promo Start Date"
                type="date"
                value={promoStartDate}
                onChange={(date) => setPromoStartDate(date)}
              />
            </div>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <div style={{ width: '200px' }}>Promo End Date</div>
            <div>
              <CustomDatePicker
                className='add-request-datepicker'
                placeholderText="Select Promo End Date"
                type="date"
                value={promoEndDate}
                onChange={(date) => setPromoEndDate(date)}
              />
            </div>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <div style={{ width: '200px' }}>Remark by Requester</div>
            <div>
              <CustomInput
                style={{ marginLeft: '88px', width: '440px', height: '50px' }}
                type="text"
                placeholder="Enter the description of this SKU"
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
              />
            </div>
          </div>

          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '30px' }}>
            <Button className='requester-search-btn' style={{ marginRight: '40px' }}>SAVE</Button>
            <Button className='requester-search-btn' onClick={onCancel}>CANCEL</Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddRequest;